import ListImplementation from './implementation/ListImplementation';
var ListComponent = ListImplementation;
export default ListComponent;
//# sourceMappingURL=ListComponent.js.map